export function translate(str, dict) {
    return dict[str] || str;
}
